import React, { useState } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { ShiftData } from "../../interface/timesheet";
import { apiGetEmployeeTimesheet } from "../../api/employment";
import ShiftDisplay from "../timesheet/ShiftDisplay";

interface EmployeeTimesheetProps {
  employeeId: string;
}

const EmployeeTimesheet: React.FC<EmployeeTimesheetProps> = ({
  employeeId,
}) => {
  const [tabValue, setTabValue] = useState(0);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["employeeTimesheet", employeeId, tabValue],
    queryFn: () => apiGetEmployeeTimesheet(employeeId, "1", "20"),
    enabled: !!employeeId,
    staleTime: 2 * 60 * 1000,
  });

  const absentShifts: ShiftData[] = data?.data?.data?.absentShifts || [];
  const upcomingShifts: ShiftData[] = data?.data?.data?.upcomingShifts || [];
  const completedShifts: ShiftData[] = data?.data?.data?.completedShifts || [];

  if (isLoading) {
    return (
      <Box sx={{ width: "100%" }}>
        <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={200} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error" sx={{ textAlign: "center", py: 4 }}>
        Failed to load timesheet data
      </Typography>
    );
  }

  return (
    <ShiftDisplay
      completedShifts={completedShifts}
      upcomingShifts={upcomingShifts}
      absentShifts={absentShifts}
    />
  );
};

export default EmployeeTimesheet;
